/**
 * The emoji offered by the composer picker.
 *
 * Deliberately a hand-curated list rather than a full emoji library: a picker
 * package ships ~1MB of emoji data and search index for what is, here, a grid
 * of buttons. Adding an emoji is a one-line change to this file — the value is
 * stored as plain text in ActivityLog.content, so there is no enum, migration
 * or backend change involved.
 *
 * Groups are ordered by how often a recruiter is likely to want them.
 */

export interface EmojiGroup {
  label: string
  emojis: string[]
}

export const EMOJI_GROUPS: EmojiGroup[] = [
  {
    label: 'Reactions',
    emojis: ['👍', '👎', '✅', '❌', '🎉', '🙌', '👏', '🔥', '💯', '⭐'],
  },
  {
    label: 'Faces',
    emojis: [
      '🙂',
      '😀',
      '😅',
      '😂',
      '😉',
      '😊',
      '😍',
      '😎',
      '🥳',
      '🤔',
      '😐',
      '😕',
      '😢',
      '😮',
      '😬',
      '🙃',
    ],
  },
  {
    label: 'Gestures',
    emojis: ['🙏', '💪', '🤝', '👋', '👀', '✍️'],
  },
  {
    label: 'Work',
    emojis: [
      '📞',
      '📱',
      '📧',
      '📄',
      '📅',
      '⏰',
      '🚚',
      '⚠️',
      '💰',
      '🏆',
      '❤️',
      '🔗',
    ],
  },
]

/** Flat list of every offered emoji, handy for tests and sanity checks. */
export const ALL_EMOJIS = EMOJI_GROUPS.flatMap((group) => group.emojis)
